import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const MyAssignments = ({ token, apiCall }) => {
  const [assignments, setAssignments] = useState([]);
  const [confirming, setConfirming] = useState(null);

  const load = useCallback(async () => {
    try {
      const data = await apiCall('/my/assignments', 'GET', null, token);
      setAssignments(data || []);
    } catch { /* silent */ }
  }, [apiCall, token]);

  useEffect(() => { load(); }, [load]);

  if (assignments.length === 0) return null;

  return (
    <Card data-testid="my-assignments-section">
      <CardHeader>
        <CardTitle>My Assignment Details</CardTitle>
        <p className="text-sm text-slate-500">Your Assignment Details documents. Please view and confirm receipt.</p>
      </CardHeader>
      <CardContent className="space-y-3">
        {assignments.map((a) => (
          <div
            key={a.id}
            className={`flex flex-wrap items-center justify-between gap-3 p-4 rounded-lg border ${a.acknowledged ? 'bg-green-50 border-green-200' : 'bg-purple-50 border-purple-200'}`}
            data-testid={`my-assignment-${a.id}`}
          >
            <div>
              <p className="font-medium">{a.work_type} — {a.client_name}</p>
              <p className="text-xs text-slate-500">
                Starts {a.start_date} • {a.likely_duration} • v{a.version}
              </p>
              {a.acknowledged ? (
                <p className="text-xs text-green-700 mt-1">
                  ✓ Receipt confirmed on {new Date(a.acknowledged_at).toLocaleDateString('en-GB')}
                </p>
              ) : (
                <p className="text-xs text-purple-700 mt-1">⏳ Please confirm you have received this document</p>
              )}
            </div>
            <div className="flex gap-2">
              {a.pdf_url && (
                <a href={`${BACKEND_URL}${a.pdf_url}?token=${token}`} target="_blank" rel="noopener noreferrer">
                  <Button variant="outline" size="sm" data-testid={`view-assignment-pdf-${a.id}`}>📄 View PDF</Button>
                </a>
              )}
              {!a.acknowledged && (
                <Button
                  size="sm"
                  className="bg-green-600 hover:bg-green-700"
                  disabled={confirming === a.id}
                  data-testid={`confirm-assignment-receipt-${a.id}`}
                  onClick={async () => {
                    setConfirming(a.id);
                    try {
                      const res = await apiCall(`/assignments/${a.id}/acknowledge`, 'POST', {}, token);
                      toast.success(res.message || 'Receipt confirmed');
                      load();
                    } catch {
                      toast.error('Failed to confirm receipt');
                    }
                    setConfirming(null);
                  }}
                >
                  ✓ Confirm Receipt
                </Button>
              )}
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
